import React from 'react';
import classnames from 'classnames';

interface SpinnerProps {
  small?: boolean;
  tiny?: boolean;
  inline?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ small, tiny, inline }) => {
  return (
    <div
      className={classnames({
        'aha-spinner': true,
        'aha-spinner--small': small,
        'aha-spinner--tiny': tiny,
        'aha-spinner--inline': inline,
      })}
      role='spinner'
    >
      <div className='aha-spinner__icon' />
    </div>
  );
};

export default Spinner;
